export const DEFAULT_POSITION = 'top center';
export const DEFAULT_OPEN_DELAY = 400;
